import dayjs from 'dayjs'

import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

export const signUpEndTimeValidator: SchemaItem['x-validator'] = [
  {
    required: true
  },
  {
    validator(_, __, ctx) {
      const { signUpStartTime, signUpEndTime } = ctx.form.values

      if (signUpStartTime && dayjs(signUpEndTime).isBefore(signUpStartTime)) {
        return '报名结束时间必须大于报名开始时间'
      }
      return null
    }
  }
]
